<script setup lang="ts">
import CabHeader from '@/views/header/CabHeader.vue';
import CabLink from '@/views/header/CabLink.vue';
import {onMounted, onUnmounted} from 'vue';
import {done, loadingState, reload} from '@/base/loadingState.js';
import LoadingStateView from '@/views/general/LoadingStateView.vue';
import {stateForReporters, fetchAndSetState, startStatePolling, stopStatePolling} from '@/base/TMP_globalState.js';
import {AvailabilityState} from 'common';
import {RouterView} from 'vue-router';

// Placeholder badge values for demonstration; replace with real data as needed
const numTeAccepteren = 0;
const numGeaccepteerd = 0;
const numAfgewezen = 0;

onMounted(async () => {
    await reload();
    await fetchAndSetState();
    startStatePolling();
});

onUnmounted(() => {
    stopStatePolling();
});
</script>

<template>
    <div class="h-screen relative">
        <CabHeader>
            <CabLink name="te doen" to="/accept/te-doen" :badge-value="numTeAccepteren" badge-color="blue"/>
            <CabLink name="geaccepteerd" to="/accept/geaccepteerd" :badge-value="numGeaccepteerd" badge-color="green"/>
            <CabLink name="afgewezen" to="/accept/afgewezen" :badge-value="numAfgewezen" badge-color="red"/>
        </CabHeader>
        <LoadingStateView :state="loadingState" :stateForReporters="stateForReporters"/>
        <RouterView v-if="done && stateForReporters!==AvailabilityState.closed"/>
    </div>
</template>
